import {
    booleanAttribute,
    Directive,
    ElementRef,
    inject,
    input,
} from '@angular/core';

const INTERACTIVE_TARGETS =
    'button, a, input, select, textarea, label, summary, [role="button"], [role="checkbox"], [role="menuitem"], [role="switch"], [tabindex], [contenteditable], [data-row-action-ignore]';

@Directive({
    selector: '[qpxRowAction]',
    host: {
        'data-row-action-host': '',
        '[class.qpx-row-action]': 'enabled()',
        '(click)': 'onClick($event)',
    },
})
export class QpxRowAction {
    private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);

    public readonly enabled = input(true, {
        alias: 'qpxRowAction',
        transform: booleanAttribute,
    });

    protected onClick(event: MouseEvent): void {
        if (
            !this.enabled() ||
            event.defaultPrevented ||
            event.button !== 0 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
        )
            return;

        const row = this.element.nativeElement;
        const selection = row.ownerDocument.getSelection();
        if (selection && !selection.isCollapsed && selection.toString().trim())
            return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        const interactiveTarget = target.closest(INTERACTIVE_TARGETS);
        if (interactiveTarget && row.contains(interactiveTarget)) return;

        const action = row.querySelector<HTMLButtonElement | HTMLAnchorElement>(
            'button[data-row-action], a[data-row-action]'
        );
        if (
            !action ||
            action.matches(':disabled, [aria-disabled="true"]') ||
            action.closest('[inert]')
        )
            return;

        action.focus({ preventScroll: true });
        action.click();
    }
}
